module.exports = __webpack_public_path__ + "img/dashboard-menu.d05d4871.svg";